const SCROLLING_CLASS = '--scrolling'
const HIDE_DELAY = 800

// The scrollbars are hidden until their element is hovered (styles/_scrollbar.scss). While an element scrolls (wheel,
// keys, touch, program) it gets the class `--scrolling` too, and loses it shortly after the last scroll event.
const initScrollbarVisibility = (): (() => void) => {
    const timers = new WeakMap<Element, ReturnType<typeof setTimeout>>()

    const onScroll = (event: Event): void => {
        // scrolling the page fires on the document
        const element = event.target instanceof Element ? event.target : document.documentElement

        element.classList.add(SCROLLING_CLASS)
        clearTimeout(timers.get(element))
        timers.set(element, setTimeout(() => element.classList.remove(SCROLLING_CLASS), HIDE_DELAY))
    }

    // `scroll` does not bubble: capture it to hear every element
    document.addEventListener('scroll', onScroll, { capture: true, passive: true })

    return () => document.removeEventListener('scroll', onScroll, { capture: true })
}

export default initScrollbarVisibility
